<template>
  <div
    class="w-[100vw] h-[100vh] fixed top-0 left-0 flex justify-center items-center bg-[#0000005a] z-[9999]"
  >
    <div
      class="text-white gap-4 p-4 bg-[#5D5D98] rounded-[10px] flex flex-col max-h-[90vh] overflow-y-auto glass-app popup-content"
    >
      <div class="w-full gap-[2rem] flex justify-between items-center">
        <h3 class="text-[#ff9b05]">{{ edit_mode ? title : "Visualizar" }}</h3>
        <div class="flex gap-2 items-center">
          <AppButton
            v-if="edit_mode"
            v-bind:visibility="true"
            :font_size="12"
            color="#ff9b05"
            left_icon="fa-solid fa-pen-to-square"
            text="Salvar"
            emitType="select"
            @select="save_config"
          />
          <AppButton
            class="text-white"
            v-bind:visibility="true"
            left_icon="fa-regular fa-circle-xmark fa-xl"
            emitType="close"
            @close="close"
            :width="23"
            :height="23"
          />
        </div>
      </div>
      <div class="flex flex-col gap-2 ">
        <div
          v-if="
            modelCopy.extendedProps?.negocio_id ||
            modelCopy.extendedProps?.ordem_servico_id
          "
          class="w-full flex justify-center gap-4 text-xs text-[#c8c8e0]"
        >
          <span v-if="modelCopy.extendedProps?.negocio_id"
            >Negócio:
            <span class="text-[#ff9b05] font-semibold"
              >#{{ modelCopy.extendedProps.negocio_id }}</span
            ></span
          >
          <span v-if="modelCopy.extendedProps?.ordem_servico_id"
            >Ordem de Serviço:
            <span class="text-[#ff9b05] font-semibold"
              >#{{ modelCopy.extendedProps.ordem_servico_id }}</span
            ></span
          >
        </div>
        <div v-for="field in model" :key="field.id">
          <div
            v-if="field.id != 'service' && field.id != 'location'"
            class="flex gap-2"
          >
            <label
              v-if="field.id != 'description'"
              class="min-w-[6rem]"
              :for="field.id"
              >{{ field.name }}:</label
            >
            <!-- Handle datetime type fields with datetime-local input -->
            <input
              class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] min-w-96 lg:max-w-40"
              v-if="field.type === 'datetime'"
              type="datetime-local"
              :id="field.id"
              v-model="modelCopy[field.id]"
              :disabled="field.disabled"
            />
            <!-- Handle text inputs -->
            <input
              class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] min-w-96 lg:max-w-40"
              v-else-if="field.type !== 'textarea'"
              :type="field.type || 'text'"
              :id="field.id"
              v-model="modelCopy[field.id]"
              :disabled="field.disabled"
              :class="{ 'red-border': isEmptyField(field.id) }"
            />

            <!-- <textarea class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] resize-none w-96 h-80" v-else-if="field.type === 'textarea'" :id="field.id" v-model="modelCopy[field.id]"></textarea> -->

            <!-- Handle textarea inputs -->
          </div>
        </div>
        <div class="flex gap-2">
          <label class="min-w-[6rem]" for="description">Descrição:</label>
          <textarea
            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] resize-none w-96 h-80"
            id="description"
            v-model="modelCopy['description']"
          ></textarea>
        </div>
      </div>

      <!-- <div class="set_data_container rounded-[10px] flex gap-4  bg-[#5d5d988c]">
                <div v-for="(value, key) in setDataCopy" :key="key">
                    <div v-if="key != 'endereco' && key != 'contrato'" class="ser_data flex items-center gap-1">
                        <label class="" for="Any">{{ key }}:</label>
                        <div v-bind:style="{ color: value.id === 0 ? 'red' : '#ff9b05' }">
                            {{ value.nome ? value.nome : value.numero }}
                        </div> -->

      <!-- <AppButton class="capitalize" v-bind:visibility="true" :font_size="12" color="#ff9b05"
                        left_icon="fa-solid fa-pen-to-square" text="" emitType="select"
                        @select="open_dialog_alert(key)" /> -->

      <!-- <button v-if="key == 'servico'" @click="open_dialog_alert(key)" :style="{color: setDataCopy.zona.id!=0 ?'#ff9b05':'#7B7B99'}  ">
                            <Icon class="edit-icon" icon="lucide:edit" />
                        </button>

                        <button v-else @click="open_dialog_alert(key)" style="color: #ff9b05; ">
                            <Icon class="edit-icon" icon="lucide:edit" />
                        </button> -->

      <!-- </div>
                </div>

            </div> -->
      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
      >
        <div
          v-for="(value, key) in checkBoxesCopy"
          :key="key"
          class="flex gap-2 items-center"
        >
          <input
            type="checkbox"
            :id="value.name"
            :value="value.value"
            v-model="value.value"
          />
          <label class="text-nowrap" :for="value.name">{{ value.name }}</label>
          <div v-if="value.value && value.name == 'Faturação Agregada'">
            <select
              v-model="listChoiceCopy"
              class="bg-white text-black rounded-[5px]"
            >
              <option v-for="(value, key) in listBox" :key="key" :value="value">
                {{ value }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Dialog
    v-if="showDialog"
    :propsData="dialogProps"
    @close="closeDialog"
    @returnData="handleReturnData"
  />
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import { toast } from "vue3-toastify";
import Dialog from "@/components/dialog/dinamicDialog.vue";

export default {
  name: "genericPopUp",
  components: {
    AppButton,
    Dialog,
  },
  props: {
    title: {
      type: String,
      default: "Title",
    },
    model: {
      type: Array,
      default: () => [],
    },
    modelData: {
      type: Object,
      default: () => ({}),
    },
    checkBoxes: {
      type: Array,
      default: [],
    },
    listBox: {
      type: Array,
      default: [],
    },
    listChoice: {
      type: String,
      default: "0",
    },
    setData: {
      type: Object,
      default: () => ({}),
    },
    edit_mode: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      listChoiceCopy: JSON.parse(JSON.stringify(this.listChoice)),
      checkBoxesCopy: JSON.parse(JSON.stringify(this.checkBoxes)),
      setDataCopy: JSON.parse(JSON.stringify(this.setData)),
      modelCopy: { ...this.modelData },

      showDialog: false,
      currentType: null,

      dialogProps: {
        entity: ["equipamento", "tpiva", "tpmoeda"],
        sideBar: true,
        multi: false,
        queryParams: { equipamento: "custom=1" },
      },
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save_config() {
      let returnVal = false;
      this.checkBoxesCopy.map((checkBox) => {
        if (
          checkBox.name == "Faturação Agregada" &&
          checkBox.value &&
          this.listChoiceCopy == "0"
        ) {
          toast("Escolha uma opção para Faturação Agregada", {
            theme: "auto",
            type: "warning",
            position: "top-center",
            autoClose: 1000,
          });
          returnVal = true;
        } else if (checkBox.name == "Faturação Agregada" && !checkBox.value) {
          this.listChoiceCopy = "0";
        }
      });

      if (returnVal) {
        return;
      }

      // let checkBoxes = document.querySelectorAll("input[type='checkbox']");
      // let checkBoxesValues = [];
      // checkBoxes.forEach((checkBox) => {
      //     checkBoxesValues.push({ name: checkBox.id, value: checkBox.checked });
      // });

      console.log("checkboxes", this.checkBoxesCopy);
      console.log("listChoice", this.listChoiceCopy);
      if (!this.validateForm()) {
        return;
      }
      this.$emit(
        "save",
        this.checkBoxesCopy,
        this.listChoiceCopy,
        this.setDataCopy,
      );
      this.$emit("save_form", this.modelCopy, this.setDataCopy);
    },
    open_dialog_alert(key) {
      if (key == "iva") {
        this.dialogProps.entity[0] = "tpiva";
        this.currentType = "tpiva";
        this.showDialog = true;
      } else if (key == "zona") {
        this.dialogProps.entity[0] = "tpzona";
        this.currentType = "tpzona";
        this.showDialog = true;
      } else if (key == "tabelaPrecos") {
        this.dialogProps.entity[0] = "precario";
        this.currentType = "precario";
        this.showDialog = true;
      } else if (key == "servico") {
        if (this.setDataCopy.zona.id == 0) {
          toast("Escolha uma zona primeiro", {
            theme: "auto",
            type: "warning",
            position: "top-center",
            autoClose: 1000,
          });
          return;
        }
        this.dialogProps.entity[0] = "servico";
        this.currentType = "servico";
        this.showDialog = true;
      }

      // this.$emit('open_dialog_alert',key)
    },
    handleReturnData(data) {
      console.log("Returned data:", data);

      if (data.tpiva) {
        this.setDataCopy.iva.nome = data.tpiva.nome;
        this.setDataCopy.iva.id = data.tpiva.id;
      } else if (data.tpzona) {
        this.setDataCopy.zona.nome = data.tpzona.nome;
        this.setDataCopy.zona.id = data.tpzona.id;
      } else if (data.precario) {
        this.setDataCopy.tabelaPrecos.nome = data.precario.nome;
        this.setDataCopy.tabelaPrecos.id = data.precario.id;
      } else if (data.servico) {
        this.setDataCopy.servico.nome = data.servico.nome;
        this.setDataCopy.servico.id = data.servico.id;

        console.log("Returned data:", data);
      }
    },
    closeDialog() {
      this.showDialog = false;
    },

    getInputType(value) {
      return typeof value === "number" ? "number" : "text";
    },

    validateForm() {
      // if(this.modelCopy['name'] == '' || this.modelCopy['name'] == undefined || this.setDataCopy['servico'] == undefined || this.setDataCopy['zona'] == undefined
      // || this.setDataCopy['servico'].id == 0 || this.setDataCopy['zona'].id ==0
      // )
      // if(this.setDataCopy['servico'] == undefined || this.setDataCopy['zona'] == undefined
      // || this.setDataCopy['servico'].id == 0 || this.setDataCopy['zona'].id ==0
      // ){
      //     toast("Preencha os campos obrigatórios", {
      //         theme: "auto",
      //         type: "warning",
      //         position: "top-center",
      //         autoClose: 1000,
      //     });
      //     return false
      // }
      return true;
    },

    isEmptyField(field) {
      if (["name"].includes(field)) {
        return (
          this.modelCopy[field] === "" || this.modelCopy[field] === undefined
        );
      }

      return false;
    },
  },

  watch: {
    checkBoxes: {
      handler: function (newVal) {
        this.checkBoxesCopy = newVal;
      },
      deep: true,
    },
    listChoice: {
      handler: function (newVal) {
        this.listChoiceCopy = newVal;
      },
      deep: true,
    },
    setData: {
      handler: function (newVal) {
        this.setDataCopy = newVal;
      },
      deep: true,
    },
    model: {
      handler: function (newVal) {
        this.modelCopy = newVal;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.red-border {
  border: 1px solid white;
  background-color: rgba(176, 88, 88, 0.664);
}
</style>
